<template>
  <!-- 管理员管理 -->
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="container">
      <div class="left">
        <SelectDept v-model="searchData.deptId"></SelectDept>
        <div class="tree">
          <el-tree
            ref="tree"
            node-key="id"
            highlight-current
            :data="treeData"
            :props="defaultProps"
            :expand-on-click-node="false"
            :default-expand-all="true"
            @node-click="handleNodeClick"
          ></el-tree>
        </div>
      </div>
      <div class="right">
        <div class="header-search">
          <el-form ref="form" inline label-width="100px">
            <el-form-item label="管理员姓名">
              <el-input style="width:250px" v-model="searchData.userName" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input style="width:250px" v-model="searchData.mobile" size="small" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="角色">
              <SelectRole v-model="searchData.roleId"></SelectRole>
            </el-form-item>
            <!-- <el-form-item label="部门">
              <SelectDept v-model="searchData.deptId"></SelectDept>
            </el-form-item> -->
            <el-form-item label="岗位">
              <SelectJob v-model="searchData.jobCode"></SelectJob>
            </el-form-item>
            <el-form-item label=" ">
              <el-button type="primary" size="small" icon="el-icon-search" @click="getAdminList">搜索</el-button>
              <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.user_list_add)"
          style="margin-bottom:20px;"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="$router.push({ name: 'UserAdd' })"
          >新增</el-button
        >
        <tp-table
          :isNeedSerialNumber="false"
          :tableData="list"
          :columns="columns"
          :totalNum="total"
          :current-page.sync="currentPage"
          :pageSize.sync="pageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectRole from '@/views/components/select-role.vue'
import SelectDept from '@/views/components/select-dept.vue'
import SelectJob from '@/views/components/select-job.vue'
import { getAdminList, removeAdmin, getRoleList, changeStatus, getDeptTree } from './api'
import { authBtnMixin } from '@/mixins/authBtnMixin'
const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p>{row['id']}</p>
    }
  },
  {
    label: '用户名',
    prop: 'userName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['userName']}</p>
    }
  },
  {
    label: '手机号',
    minWidth: '120',
    prop: 'mobile',
    customRender(h, row) {
      return (
        <p class="one-line" title={row['mobile']}>
          {row['mobile']}
        </p>
      )
    }
  },
  {
    label: '微信号',
    minWidth: '150',
    prop: 'wechat',
    customRender(h, row) {
      return (
        <p class="one-line" title={row['wechat']}>
          {row['wechat'] || '-'}
        </p>
      )
    }
  },
  {
    label: '角色',
    width: '100',
    prop: 'roleName',
    customRender(h, row) {
      return <p class="one-line">{row['role']?.['roleName']}</p>
    }
  },
  {
    label: '性别',
    minWidth: '80',
    prop: 'genderName',
    customRender(h, row) {
      return <p>{row['genderName']}</p>
    }
  },
  {
    label: '部门',
    minWidth: '100',
    prop: 'dept',
    customRender(h, row) {
      return <p>{row['dept']?.['deptName']}</p>
    }
  },
  {
    label: '岗位',
    minWidth: '120',
    prop: 'job',
    customRender(h, row) {
      return <p>{row['job']?.['jobName']}</p>
    }
  },
  {
    label: '企微uid',
    minWidth: '120',
    prop: 'wxcpId',
    customRender(h, row) {
      return <p>{row['wxcpId']}</p>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            class="switch"
            onChange={() => this.changeStatus(row)}
            disabled={row['isSuper'] || !this.isShowBtn(this.AUTH_BTN.user_list_status)}
            v-model={row['status']}
            active-value={1}
            inactive-value={0}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      )
    }
  },
  {
    label: '创建时间',
    minWidth: '180',
    prop: 'createTime',
    customRender(h, row) {
      return (
        <p class="one-line" title={row['createTime']}>
          {row['createTime']}
        </p>
      )
    }
  },
  {
    label: '操作',
    fixed: 'right',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-link
            v-show={this.isShowBtn(this.AUTH_BTN.user_list_edit)}
            disabled={row['isSuper'] == 1}
            underline={false}
            type="primary"
            onClick={() => this.$router.push({ name: 'UserEdit', params: { id: row['id'] } })}
          >
            编辑
          </el-link>
          <el-link
            v-show={this.isShowBtn(this.AUTH_BTN.user_list_del)}
            disabled={row['isSuper'] == 1}
            underline={false}
            style="margin:0 10px"
            type="primary"
            onClick={() => this.goRemove(row['id'])}
          >
            删除
          </el-link>
        </div>
      )
    }
  }
]
export default {
  name: 'Index',
  mixins: [authBtnMixin],
  components: { SelectDept, SelectJob, SelectRole },
  data() {
    return {
      dialogVisible: false,
      isShow: false,
      list: [],
      pageSize: 10,
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      searchData: {
        userName: '',
        mobile: '',
        roleId: '',
        deptId: '',
        jobCode: ''
      },
      total: 0,
      currentPage: 1,
      columns,
      roleList: [],
      treeData: [],
      currentDept: {} //树形的每项数据
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getAdminList()
    },
    pageSize() {
      this.getAdminList()
    },
    treeData: {
      handler() {
        if (!this.currentDept.id) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].id)
            this.currentDept = this.$refs.tree.getCurrentNode()
            this.getAdminList()
          })
        }
      }
    },
    'searchData.deptId': {
      handler(newV, oldV) {
        this.$refs.tree.setCurrentKey(newV)
        this.getAdminList()
      }
    }
  },

  mounted() {
    this.getRoleList()
    this.getDeptTree()
  },

  methods: {
    async getRoleList() {
      let params = { page: 1, pageSize: 50 }
      const res = await getRoleList(params)
      this.roleList = res.list || []
    },
    async getAdminList() {
      const { userName, mobile, roleId, jobCode } = this.searchData
      const { id } = this.currentDept
      let params = { userName, mobile, roleId, deptId: id, jobCode, page: this.currentPage, pageSize: this.pageSize }
      let res = await getAdminList(params)
      this.list = res?.list || []
      this.total = res?.total || 0
    },

    goAdd() {
      this.$router.push({ name: 'MemberDetail' })
    },
    goEdit(id) {
      this.$router.push({ name: 'MemberDetail', params: { id: id || undefined } })
    },
    async goRemove(id) {
      this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeAdmin({ id }).then(() => {
            this.$message.success('删除成功')
            this.getAdminList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getAdminList()
    },
    changeStatus(row) {
      let { id, status } = row
      let data = { id, status: status == 0 ? 0 : 1 }
      let statusDesc = status == 0 ? '禁用' : '启用'

      this.$confirm(`此操作将该管理员${statusDesc}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status == 0 ? 0 : 1
          changeStatus(data).then(() => {
            this.getAdminList()
            this.$message.success('操作成功')
          })
        })
        .catch(() => {
          row.status = status == 1 ? 0 : 1
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async getDeptTree() {
      const res = await getDeptTree()
      this.treeData = res || []
      this.$nextTick(() => {
        // this.$refs.tree.setCurrentKey(this.currentDept.id)
        this.currentDept = this.$refs.tree.getCurrentNode()
      })
    },
    handleNodeClick(data, node) {
      this.currentDept = data
      this.getAdminList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form /deep/ {
      .el-form-item {
        margin-right: 35px;
      }
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper {
  .container {
    display: flex;
    height: calc(100% - 23px);
    .left {
      border-right: 1px solid #ccc;
      margin-right: 20px;
      .el-cascader {
        min-width: 200px;
        max-width: 300px;
        margin: 10px;
      }
      .tree {
        min-width: 200px;
        max-width: 300px;
        .el-tree /deep/ {
          .el-tree-node__content {
            height: 40px;
            .el-tree-node__expand-icon {
              margin-left: 20px;
            }
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background-color: #e6f7ff;
            border-right: 3px solid #1890ff;
            .el-tree-node__label,
            .el-tree-node__expand-icon {
              color: #1890ff;
            }
            .el-tree-node__expand-icon.is-leaf {
              color: transparent !important;
            }
          }
        }
      }
    }
    .right {
      min-width: 800px;
    }
  }
}
</style>
